module.exports = __webpack_public_path__ + "img/icons.67358ae4.svg";